import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setIsStreamingAction } from "../../store/profile/actions";

interface SrsPublisherProps {
  srsHost?: string;
  streamKey?: string;
}

export default function SrsPublisher({ srsHost = "localhost", streamKey = "mystream" }: SrsPublisherProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  console.log("SrsPublisher", srsHost, streamKey);
  const dispatch = useDispatch();

  useEffect(() => {
    let pc: RTCPeerConnection | null = null;
    let localStream: any = null;

    const publishStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });
        localStream = stream;

        console.log("Local stream obtained:", stream);
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }

        const offerUrl = `https://stream.boltplus.tv/rtc/v1/publish/`;
        const streamUrl = `webrtc://${srsHost}/live/${streamKey}`;

        pc = new RTCPeerConnection();

        // Add tracks to peer connection
        stream.getTracks().forEach((track) => pc?.addTrack(track, stream));

        // Create offer
        const offer = await pc.createOffer();
        console.log("Offer created:", offer);
        await pc.setLocalDescription(offer);

        // Send offer to SRS via HTTP API
        const response = await fetch(offerUrl, {
          method: "POST",
          body: JSON.stringify({
            api: offerUrl,
            streamurl: streamUrl,
            clientip: null,
            sdp: offer.sdp,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        // Set SRS answer
        await pc.setRemoteDescription(
          new RTCSessionDescription({
            type: "answer",
            sdp: data.sdp,
          })
        );
        // dispatch(setIsStreamingAction(true));
        console.log("Publishing to", streamUrl);
      } catch (err) {
        console.error("Error publishing stream:", err);
      }
    };

    publishStream();

    return () => {
      const peerConnection = pc as RTCPeerConnection | null;
      if (peerConnection) {
        peerConnection.close();
      }
      if (localStream) {
        (localStream as MediaStream).getTracks().forEach((track: MediaStreamTrack) => track.stop());
      }
    };
  }, [srsHost, streamKey]);

  return <video ref={videoRef} autoPlay muted playsInline style={{ width: "100%", height: 600 }} />;
}
